module.exports = __webpack_public_path__ + "img/Carte-apaym-pro.b24b08b7.png";